import { listPlansByItemIdentifier } from '@wix/ambassador-pricing-plans-v3-plan-benefit-http/http';
import { blogAppDefId } from '../constants/apps';
import { type FlowAPI } from '../types';

export const fetchPlanIdsForPost = async (
  httpClient: FlowAPI['httpClient'],
  postId: string | undefined,
): Promise<string[]> => {
  if (!postId) {
    return [];
  }

  try {
    const response = await httpClient.request(
      listPlansByItemIdentifier({
        itemIdentifier: { externalId: postId, providerAppId: blogAppDefId },
        count: 3,
      }),
    );

    const planIds: string[] = [];
    for (const planBenefit of response.data?.planBenefits ?? []) {
      const id = planBenefit.planInfo?.plan?.id;
      if (id) {
        planIds.push(id);
      }
    }
    return planIds;
  } catch {
    return [];
  }
};
